  <template>
  <div class="page-not-found">
    <div class="page-not-found__wrapper">
      <div class="page-not-found__title">404</div>
      <div class="page-not-found__description">The page you are looking for can not be found. </div>
      <div class="page-not-found__button-group">
        <ButtonPrimary title="Return to Homepage" type="link" link="/"></ButtonPrimary>
        <ButtonPrimary @buttonClick="goBack()" title="Return to previous page" type="button" link="#"></ButtonPrimary>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonPrimary from "../../../components/global/ButtonPrimary"


export default {
  name: 'PageNotFound',
  data: () => ({
  }),
  components: {
    ButtonPrimary
  },
  created () {
  },
  mounted () {
  },
  methods: {
    goBack () {
      window.history.go(-2)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../scss/global/includes";

.page-not-found {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.page-not-found__wrapper {
  width: 420px;
  padding: 0 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
}

.page-not-found__title {
  color: #000000;
  width: 100%;
  font-size: 80px;
  font-family: $font-medium;
  line-height: 1;
}

.page-not-found__description {
  color: #000000;
  width: 100%;
}

.page-not-found__button-group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}


</style>
